import { createApiClient } from '@drama/api-sdk'
import { createLocalTokenStore } from '@drama/app-boot/vg-token-store'

/**
 * @param {{ baseUrl: string, getLocale?: () => string, fetchImpl?: typeof fetch }} opts
 */
export function createVisualGameAdminClient(opts) {
  if (!opts || typeof opts.baseUrl !== 'string') {
    throw new Error('createVisualGameAdminClient: opts.baseUrl is required')
  }
  let client
  const tokenStore = createLocalTokenStore({
    refreshSession: request => client.auth.refresh(request),
    deviceKey: 'visualGameAdmin.deviceId',
    devicePrefix: 'vga-',
  })
  client = createApiClient({
    baseUrl: opts.baseUrl,
    tokenStore,
    getLocale: opts.getLocale,
    fetchImpl: opts.fetchImpl,
    onAuthExpired: () => tokenStore.clear(),
  })
  return Object.assign(client, { tokenStore })
}
